import React, { Component, useState } from "react";
import Slider from "react-slick";
import "./Photo.css";
const Photo = () => {
  var settings = {
    dots: false,
    infinite: true,

    slidesToShow: 3,
    slidesToScroll: 1,

    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 4000,
    centerMode: true,

    beforeChange: (current, next) => setImageIndex(next),

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let images = [
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5018_p2dxd_iQw.jpg?updatedAt=1678609437530",
    "https://ik.imagekit.io/euo36lugk/Nutrire/taylorutah_WH_FMsT1j.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606534282",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2431_GDPFNhz9X.JPG?updatedAt=1682999154150",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2314_nLzOJ8-cy.jpg?updatedAt=1682999132133",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2396_jxY1sgppL.jpg?updatedAt=1682999135218",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_47D27AA6-18B4-4ED8-9D79-BF7B4BD9CE93_Zf_i4bAig.JPG?updatedAt=1682999132398",
    "https://ik.imagekit.io/euo36lugk/Nutrire/image0_6CdsGwpwLH.jpeg?updatedAt=1678609479278",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_3100_0PDd91VKQ.jpg?updatedAt=1678609448364",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5209_-aDpKve-8c.jpg?updatedAt=1678609446982",
  ];

  const [imageIndex, setImageIndex] = useState(0);
  return (
    <div className="photo">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div className={index === imageIndex ? "slide activeSlide" : "slide"}>
            <img src={image} alt={image} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Photo;
